import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'heading-s-bold bg-bg-items-white m-1 flex shrink-0 items-center gap-2 rounded-full px-4 py-2',
    closeButton: 'size-5 cursor-pointer rounded-full border',
    closeIcon: 'text-main size-4.5'
  }
});
